import GroupingPackageDetail from "./grouping-package-detail";

export default class GroupingPackage {
    groupingPackageCode:string;
    aoGroupCode:string;
    customerName: string;
    shippingFullAddress:string;
    customerPhone:string;
    tplCode:string;
    sumPackage:number;
    status:string;
    statusName:string;
    tplName: string;
    packages: Array<GroupingPackageDetail>;
}